import { Controller } from "stimulus";
import NotificationService from "../entrypoints/src/admin/services/notification-service";

export default class extends Controller {
  connect() {
    this.$notificationLink = this.element.querySelector('.notification-link');
    this.dropdownNotification = this.element.querySelector('#dropdown-notifications');
    this.dropdownNotification.style.position = 'absolute';
    this.dropdownNotification.style.top = `${this.$notificationLink.offsetHeight + 20}px`;
    this.dropdownNotification.style.right = '0px';
    if (this.$notificationLink) {
      this.$notificationLink.addEventListener('click', this.onShowUpNotifications.bind(this));
    }

    document.addEventListener("turbo:frame-load", this.handleTurboFrameLoad.bind(this));
  }

  handleTurboFrameLoad(event) {
    const turboFrame = event.target;

    if (turboFrame.id === "turbo-modal") {
      this.setupModalNotifications(turboFrame);
      this.closeDropdownNotifications();
    }
  }

  setupModalNotifications(modalElement) {
    this.bindEvents(modalElement);
  }

  bindEvents(context = this.element) {
    this.$markAllRead = context.querySelector('a#mark-all-read');
    // The badge text is capped at "+99"; the real count lives in data-unread-count.
    this.unreadAmount = +document.querySelector('.unread-notifications').dataset.unreadCount;

    if (this.$markAllRead) {
      this.$markAllRead.addEventListener('click', this.markAllRead.bind(this));
    }
    this.markReadNotification(context);
    this.anchorUnreadNotification(context);
  }

  async markAllRead(ev) {
    ev.preventDefault();
    if (this.unreadAmount == 0) return;

    await Promise.all([NotificationService.readAll(), NotificationService.readAllMentions()]);

    this.element.querySelectorAll('.notification').forEach(($li) => this.markAsRead($li));

    const modalFrame = document.querySelector('turbo-frame#turbo-modal');
    if (modalFrame) {
        modalFrame.querySelectorAll('.notification').forEach(($li) => this.markAsRead($li));
    }

    const bellFrame = document.querySelector('turbo-frame#notifications-bell-frame');
    if (bellFrame) {
        bellFrame.querySelectorAll('.notification').forEach(($li) => this.markAsRead($li));
    }

    // Mention rows carry no per-item read toggle, so just flip their visual state.
    document.querySelectorAll('.mention-notification.unread').forEach(($li) => $li.classList.replace('unread', 'read'));

    // Clear the combined numeric badge (portal notifications + mentions).
    const badge = document.querySelector('.unread-notifications');
    if (badge) {
      badge.innerText = '0';
      badge.dataset.unreadCount = '0';
      badge.classList.add('hidden');
    }
    this.unreadAmount = 0;
  }

  markAllAsReadInContext(context) {
    context.querySelectorAll('.notification').forEach(($li) => this.markAsRead($li));
  }

  markReadNotification(context = this.element) {
    context.querySelectorAll('.notification a:not(.read-action)').forEach(($anchor) => {
      $anchor.addEventListener('click', async (ev) => {
        let $li = $anchor.closest('.notification'),
          notifierId = $li.dataset.notificationReceiverId;

        await NotificationService.read(notifierId);
        this.markAsRead($li);

        this.syncNotificationState(notifierId, true);
      });
    });
  }

  anchorUnreadNotification(context = this.element) {
    context.querySelectorAll('.notification a.read-action').forEach(($anchor) => {
      $anchor.addEventListener('click', async (ev) => {
        ev.preventDefault();

        $('.tooltip.fade.in').remove();

        let $li = $anchor.closest('.notification'),
          notifierId = $li.dataset.notificationReceiverId;

        if ($li.classList.contains('read')) {
          await NotificationService.unread(notifierId);
          this.markAsUnread($li);

          this.syncNotificationState(notifierId, false);
        } else {
          await NotificationService.read(notifierId);
          this.markAsRead($li);

          this.syncNotificationState(notifierId, true);
        }
      });
    });
  }

  syncNotificationState(notificationId, isRead) {
    const bellFrame = document.querySelector('turbo-frame#notifications-bell-frame');
    if (bellFrame) {
      const notificationItem = bellFrame.querySelector(`.notification[data-notification-receiver-id="${notificationId}"]`);

      if (notificationItem) {
        if (isRead) {
          this.markAsRead(notificationItem);
        } else {
          this.markAsUnread(notificationItem);
        }
      }
    }
  }

  markAsRead($li) {
    $li.classList.replace('unread', 'read');
    $li.querySelector('a.read-action').setAttribute('title', 'Marcar como não lida');

    this.unreadAmount -= 1;
  }

  markAsUnread($li) {
    $li.classList.replace('read', 'unread');
    $li.querySelector('a.read-action').setAttribute('title', 'Marcar como lida');

    this.unreadAmount += 1;
  }

  onShowUpNotifications(ev) {
    ev.preventDefault();
    this.$notificationLink.classList.remove('has-unread');
    this.dropdownNotification.classList.toggle('hidden');

    let turboFrame = this.element.querySelector('turbo-frame#notifications-bell-frame');
    if (!turboFrame.getAttribute('src')) {
      turboFrame.setAttribute('src', turboFrame.dataset.src);
    }

    turboFrame.loaded.then(() => {
      this.bindEvents();
    });
  }

  closeDropdownNotifications() {
    const dropdown = this.element.querySelector('#dropdown-notifications');
    if (dropdown && !dropdown.classList.contains('hidden')) {
      dropdown.classList.add('hidden');
    }
  }
}
